// removed by extract-text-webpack-plugin
module.exports = {"logo":"_3kPzVIj4nkSiWQjzzj-Vpx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/blog-logo/BlogLogo.css
// module id = 401
// module chunks = 0